var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvocado(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 280 280",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1113_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1114_",
    style: {
      fill: "#804C09"
    },
    d: "M155,65c0,8.284-6.716,15-15,15l0,0c-8.284,0-15-6.716-15-15V15 c0-8.284,6.716-15,15-15l0,0c8.284,0,15,6.716,15,15V65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1115_",
    style: {
      fill: "#91DC5A"
    },
    d: "M192.039,50.115C180.716,32.71,162.256,20,140,20S99.284,32.71,87.961,50.115 C76,68.5,45,129.667,45,185c0,52.467,42.533,95,95,95s95-42.533,95-95C235,129.667,204,68.5,192.039,50.115z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1116_",
    style: {
      fill: "#64C37D"
    },
    d: "M140,20c-22.256,0-40.716,12.71-52.039,30.115C76,68.5,45,129.667,45,185 c0,52.467,42.533,95,95,95C140,243,140,56.5,140,20z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1117_",
    style: {
      fill: "#BD720D"
    },
    cx: 140,
    cy: 185,
    r: 55
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1118_",
    style: {
      fill: "#804C09"
    },
    d: "M140,240c-30.375,0-55-24.624-55-55s24.625-55,55-55"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvocado);
export default __webpack_public_path__ + "static/media/avocado.7b1d3be26bd30209443ff2f69f251cb0.svg";
export { ForwardRef as ReactComponent };